import React, { useState } from "react";
import LoginForm from "./authentication/LoginForm";
import {useSelector} from "react-redux";

function WelcomePage() {
    const authToken = useSelector(state => state.authentication.authToken);
    const userGroups = useSelector(state => state.authentication.userGroups);
    const [showLoginForm, setShowLoginForm] = useState(false);
    const handleLoginClick = () => {
        setShowLoginForm(true);
    };

    if (authToken && userGroups && !showLoginForm) {
        return (
            <div className="container my-5">
                <div className="row justify-content-center">
                    <div className="col-md-6 text-center">
                        <h1 className="mb-3">Willkommen zur Mitverwendungsdatenbank</h1>
                        <p>Sie sind bereits angemeldet.</p>
                        <button onClick={handleLoginClick} className="btn btn-primary mt-3">
                            Zur Mitverwendungsdatenbank
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="container my-5">
            <div className="row justify-content-center">
                <div className="col-md-6 text-center">
                    {/* Logo Platzhalter */}
                    <img src="logo.svg" alt="Logo" className="mb-4" style={{ maxWidth: '1200px' }} />

                    <h3 className="mb-3">Willkommen zur Mitverwendungsdatenbank</h3>
                    <p>Hier finden Sie alle Informationen zu unseren Mitverwendungen.</p>

                    {/* LoginForm Button */}
                    {!showLoginForm && (
                        <div className="mt-4">
                            <button onClick={handleLoginClick} className="btn btn-primary">
                                Login
                            </button>
                        </div>
                    )}

                    {/* LoginForm Form */}
                    {showLoginForm && (
                        <LoginForm/>
                    )}
                </div>
            </div>
        </div>
    );
}

export default WelcomePage;
